import React, { useEffect, useRef, useState } from "react";
import { colors, fonts, glyphs } from "../../../../Styles";
import { ButtonList, Button, NewCreatableSelect, NewInputList, NewInputListHandles, NewInput } from "../../../../Components";
import { ListStyle_Types, ButtonTypes, NewFieldStyles } from "../../../../Definitions";

// Data
import { Graph_QL, useGetDomainLog, useGetAutopig } from "../../../../Services/Agrisys_GqlDataCaller"
import { Log_Item } from "../../../../Services/Agrisys_GqlDataCaller/DeviceCalls/DeviceSlices/logSlice";


/* eslint-disable no-unused-vars */
enum LogBtns {
  GetLog="Get Log", 
  LiveScales="Live Scale", 
  InternalScales="Internal Scale", 
  DailyScales="Daily Scales", 
  Clear="Clear"
}

enum SoftwareBtns {
  Firmware="Firmware", 
  VmSoftware="Vm Software", 
  GlobalSettings="Global Settings", 
  WeightLimits="Weight Limits"
}
/* eslint-enable no-unused-vars */

// #region | ViewBlocks Logs and Data
function DefaultViewBlock() {
  return (
    <div>
      Hey
    </div>
  )
}

interface LiveViewBlock_Props {
  LiveScales?: (Omit<any, "con"> & Pick<Graph_QL.ConnectionObj, "domain">)[]
}
function LiveViewBlock({LiveScales}:LiveViewBlock_Props) {
  return (
    <div>
      Live Scales 
      <p>Livescale: {LiveScales&&LiveScales[0] ? LiveScales[0].value1:"No data available"}</p>
      <p>TodayAvg: {LiveScales&&LiveScales[0] ? LiveScales[0].value2 : "No data available"}</p>
      <p>RegistredWeights: {LiveScales&&LiveScales[0] ? LiveScales[0].value3 : "No data available"}</p>
      <p>YesterdayAvg: {LiveScales&&LiveScales[0] ? LiveScales[0].value4 : "No data available"}</p>
    </div>
  )
}

interface InternalViewBlock_Props {
  LiveScales?: (Omit<any, "con"> & Pick<Graph_QL.ConnectionObj, "domain">)[]
}
function InternalViewBlock({LiveScales}:InternalViewBlock_Props) {
  return (
    <div>
      Live Scales 
      <p>Livescale: {LiveScales&&LiveScales[0] ? LiveScales[0].value1:"No data available"}</p>
      <p>TodayAvg: {LiveScales&&LiveScales[0] ? LiveScales[0].value2 : "No data available"}</p>
      <p>RegistredWeights: {LiveScales&&LiveScales[0] ? LiveScales[0].value3 : "No data available"}</p>
      <p>YesterdayAvg: {LiveScales&&LiveScales[0] ? LiveScales[0].value4 : "No data available"}</p>
      <p>Min: {LiveScales&&LiveScales[0] ? LiveScales[0].value5 : "No data available"}</p>
      <p>Max: {LiveScales&&LiveScales[0] ? LiveScales[0].value5 : "No data available"}</p>
    </div>
  )
}

interface DailyViewBlock_Props {
  Scales?: (Omit<any, "con"> & Pick<Graph_QL.ConnectionObj, "domain">)[]
}
function DailyViewBlock({Scales}:DailyViewBlock_Props) {
  return (
    <div> 
      Daily Scales
      {Scales ? Scales.map((e, index) => (
        <div key={index}>
          <p>Date: {e.timestamp} Avg: {e.value1}, Count: {e.value2}, Min: {e.value3}, Max: {e.value4}</p>
        </div>
      )) : "No data available"}
    </div>
  )
}

interface LogViewBlock_Props {
  LogData: [string, Log_Item]
}
function LogViewBlock({LogData}:LogViewBlock_Props) {
  return (
    <div>
      {LogData[1].data.map((logItem, index) => (
        <div key={index}>
          {logItem.message.split('\n').map((line, lineIndex) => (
            <p key={lineIndex}>{line}</p> // Each line in a separate <p> element
          ))}
        </div>
      ))}
    </div>
  )
}
// #endregion

// #region | ViewBlocks Software
interface FirmwareBlock_Props {
}
function FirmwareBlock({}:FirmwareBlock_Props) {
  return ( <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
    <div style={{display: "flex", gap: "10px"}}>
      <NewInput
        placeholder={"New Firmware Number"}
        isRequired={false}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary
        }}
      />
      <Button
        content="Change Firmware"
        buttonType={ButtonTypes.textButton}
        overrides={{
          baseButton: {backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px"},
          contentStyles: {...fonts.fontSize4, color: colors.greyDarkPrimary}
        }}
      />
    </div>
    <div style={{width: "100%", height: "1px", backgroundColor: colors.greyTertiary}}/>
    <Button
      content="Get Available"
      buttonType={ButtonTypes.textButton}
      overrides={{
        baseButton: {backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px"},
        contentStyles: {...fonts.fontSize4, color: colors.greyDarkPrimary}
      }}
      // onClick={} will return {"data": {"getAvailableBins": ["360","361","362"]}}
    />
  </div> )
}

interface VmSoftwareBlock_Props {
}
function VmSoftwareBlock({}:VmSoftwareBlock_Props) {
  return (
    <div>
      <NewInputList
        placeholders={["Current VM Software Number", "New VM Software Number"]} 
        isRequired={[false, false]}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary
        }}
        listOverrides={{
          listStyle: ListStyle_Types.vertical
        }}
      />
    </div>
  )
}

interface GlobalSettingsBlock_Props {
}
function GlobalSettingsBlock({}:GlobalSettingsBlock_Props) {
  return (
    <div> 
      <NewInputList
        placeholders={["Scale Id", "Weight Reset", "Temp. Sensor Val.", "Water Sensor Val.", "RFID"]} 
        isRequired={[false, false, false, false, false]}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary
        }}
        listOverrides={{
          listStyle: ListStyle_Types.vertical
        }}
      />
    </div>
  )
}

interface WeightLimitsBlock_Props {
}
function WeightLimitsBlock({}:WeightLimitsBlock_Props) {
  return (
    <div>
      <NewInputList
        placeholders={["Current Weight Limit", "New Weight Limit"]}
        isRequired={[false, false]}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
        }}
        listOverrides={{
          listStyle: ListStyle_Types.vertical
        }}
      />
    </div>
  )
}
// #endregion

export default function GraphQl() {  
  const [domain, setDomain] = useState<string|undefined>(undefined)
  const inputRef=useRef<NewInputListHandles>(null)

  const {call: FetchLog, data:LogData, deleteEntries:DeleteLogs} = useGetDomainLog()
  const {getScales, getState, stateData:LiveScales, scalesData:ScalesData, deleteEntries:DeleteAutopig, } = useGetAutopig()

  const domains = [ 
    {label:"hkhornsyld"},
    {label:"demo"}
  ]
  
  //TODO: Update inside the required useGetXXX to contain fetch handler calls 
  const [DeviceData, setDeviceData] = useState<string[]>([])

  const [activeBtnGroup, setActiveBtnGroup] = useState<"log" | "software">("log")

  const [viewType, setViewType] = useState<"live" | "internal" | "daily" | "log" | "firmware" | "vmSoftware" | "globalSettings" | "weightLimits" | "default">("default")
  const [ViewContentBlock, setViewContentBlock] = useState<any|undefined>(<DefaultViewBlock/>)

    useEffect(() => {
    // THIS NEEDS UPDATET
    //PLEASE LOOK INTO A CALLBACK HOOK CALL PRIVIDED BY:
    //useGetXXXXX - LOG - AUTOPIG
      if (viewType === "live" && LiveScales && LiveScales.length) {
        setViewContentBlock(<LiveViewBlock LiveScales={LiveScales} />);
      } else if (viewType === "internal" && LiveScales && LiveScales.length) {
        setViewContentBlock(<InternalViewBlock LiveScales={LiveScales} />);
      } else if (viewType === "daily" && ScalesData && ScalesData.length) {
        setViewContentBlock(<DailyViewBlock Scales={ScalesData} />);
      } else if (viewType === "log" && LogData && Object.entries(LogData).length) {
        var data = Object.entries(LogData)
        setViewContentBlock(<LogViewBlock LogData={data[0]} />);
      } else if (viewType === "firmware") {
        setViewContentBlock(<FirmwareBlock />);
      } else if (viewType === "vmSoftware") {
        setViewContentBlock(<VmSoftwareBlock/>);
      } else if (viewType === "globalSettings") {
        setViewContentBlock(<GlobalSettingsBlock />);
      } else if (viewType === "weightLimits") {
        setViewContentBlock(<WeightLimitsBlock />);
      } else {
        setViewContentBlock(<DefaultViewBlock />);
      }
    }, [LiveScales, ScalesData, LogData, viewType]);

  // const DoFetch = () => {
  //   if (domain) {
  //     console.log("do fetch")
  //     localStorage.setItem("activedomain", domain)
  //     FetchLog(Graph_QL.newConnection({domain:domain,gate:1}))
  //   }
  // }

  const ClickHandler = (BtnEvent: LogBtns | SoftwareBtns) => {
    DeleteAutopig();
    DeleteLogs();

    if (domain && inputRef.current) {
      const gate: string | number | undefined = inputRef.current?.value(0) as string | undefined;
      const device: string | number | undefined = inputRef.current?.value(1) as string | undefined;
  
      if (gate && device) {
        const parsedGate = Number.parseInt(gate);
        const parsedDevice = Number.parseInt(device);
  
        switch (BtnEvent) {
          case LogBtns.InternalScales:
            getState(Graph_QL.create({ domain, gate: parsedGate, device: parsedDevice }));
            setViewType("internal");
            break
          case LogBtns.LiveScales:
            getState(Graph_QL.create({ domain, gate: parsedGate, device: parsedDevice }));
            setViewType("live");
            break;
          case LogBtns.DailyScales:
            getScales(Graph_QL.create({ domain, gate: parsedGate, device: parsedDevice }), 10);
            setViewType("daily");
            break;
          case LogBtns.GetLog:
            FetchLog(undefined, Graph_QL.create({ domain, gate: parsedGate, device: parsedDevice }));
            setViewType("log");
            break;
          case SoftwareBtns.Firmware:
            setViewType("firmware")
          break;
          case SoftwareBtns.VmSoftware:
            setViewType("vmSoftware");
          break;
          case SoftwareBtns.GlobalSettings:
            setViewType("globalSettings");
          break;
          case SoftwareBtns.WeightLimits:
            setViewType("weightLimits");
          break;
          default:
            break;
        }
      }
    }
  };

  // #region | Device Connection
  const deviceConnection = (
    <div style={{display: "flex", gap: "5px", justifyContent: "flex-start", alignItems: "center"}}>
      <NewCreatableSelect
        placeholder="Domain"
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyDarkPrimary
        }}
        options={domains || ''}
        isClearable
        isSearchable
        onChange={(e) => setDomain(e?.label ?? "")}
      />
      <NewInputList ref={inputRef}
        placeholders={["GateWay", "Device ID"]}  
        isRequired={[false, false]} 
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyDarkPrimary,
          fieldWidth: "137.5px"
        }}
        valueOverrides={{
          valueTypes: ["number", "number"]
        }}
        listOverrides={{
          listStyle: ListStyle_Types.horizontal
        }}
      />
      <Button
        onClick={() => DeviceData.length === 0 ? setDeviceData(["CPUID-001-NewDecive"]) : setDeviceData([])}
        content={DeviceData.length === 0 ? "Connect" : "Disconnect"}
        overrides={{
          baseButton: {height: "30px", width: "fit-content"}
        }}
      />
      <div style={{...fonts.fontSize4, color: colors.greyLightTertiary, ...fonts.header }}>
        {DeviceData}
      </div>
    </div> 
  )
  // #endregion

  return (
    // <frames.Page_inner>
    //   <frames._page_inner_header>
    //       <PageHeader topHeader='GraphQl' subHeader="Overview"/>
    //   </frames._page_inner_header>
    //   <frames._page_inner_content>
        <div style={{display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "50px 1fr", height: "100%"}}>
          <div style={{gridArea: "1/1/2/2", display: "flex", justifyContent: "space-between", padding: "0px 20px 0px 0px", alignItems: "center"}}>
            {deviceConnection}
              <ButtonList
                contents={["Log", "Config", "Software"]}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[
                  glyphs.Animal({}), 
                  glyphs.Animal({}),
                  glyphs.Animal({})
                ]}
                onClick={(i => {
                  if (i === 0) {setActiveBtnGroup("log")}
                  if (i === 1) {}
                  if (i === 2) {setActiveBtnGroup("software")}
                })}
              />
          </div>
          <div style={{gridArea: "2/1/3/2", width: "100%", height: "100%", border: "5px solid "+colors.greyPrimary, borderRadius: "10px", boxSizing: "border-box", overflow: "hidden" }}>
            
            <div style={{display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "30px 1fr", boxSizing: "border-box", height: "100%"}}>
              <div style={{gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, display: "flex", alignItems: "center", padding: "0px 20px", borderBottom: "5px solid "+colors.greyPrimary}}>
                <ButtonList 
                  contents={activeBtnGroup === "software" ? Object.values(SoftwareBtns) : Object.values(LogBtns)}
                  buttonType={ButtonTypes.textButton}
                  listOverrides={{
                    listStyle: ListStyle_Types.horizontal,
                    listGap: "20px"
                  }}
                  onClick={(e) => ClickHandler(Object.values(activeBtnGroup === "software" ? SoftwareBtns : LogBtns)[e])}
                />
              </div>
              <div style={{gridArea: "2/1/3/2", backgroundColor: colors.greyLightTertiary, overflowY: "scroll", scrollbarColor: colors.greyTertiary+colors.transparent, height: "100%", scrollbarWidth: "thin", padding: "20px"}}>
                <div style={{height: "fit-content"}}>{ViewContentBlock?ViewContentBlock:<></>}</div>
              </div>
            </div>
            
          </div>
        </div>
    //   </frames._page_inner_content>
    // </frames.Page_inner>
  );
}